<dx-chart [dataSource]="dataSource">
    <dxi-series color="#00FF00" valueField="ASUTotal" name="ASU"></dxi-series>
    <dxi-series color="#0000ff" valueField="SMRTotal" name="SMR"></dxi-series>
    <dxo-common-series-settings #seriesSettings argumentField="awardTiming" argumentType="string"
        type="line"></dxo-common-series-settings>
    <dxo-margin [bottom]="20"></dxo-margin>
    <dxo-common-axis-settings>
        <dxo-grid [visible]="true"></dxo-grid>
    </dxo-common-axis-settings>
    <dxo-legend verticalAlignment="top" horizontalAlignment="center" [visible]="isLegendVisible"></dxo-legend>
    <dxo-argument-axis [allowDecimals]="false">
    </dxo-argument-axis>
    <dxi-value-axis name="movingAvgInvestment">
        <dxo-grid [visible]="true"></dxo-grid>
        <dxo-title [text]="valueAxisTitle"></dxo-title>
    </dxi-value-axis>
    <dxo-export [enabled]="false"></dxo-export>
    <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
    <dxo-size [height]="height">
    </dxo-size>
    <dxo-title [text]="title" horizontalAlignment="center" verticalAlignment="top"></dxo-title>
</dx-chart>